import { MultiSelect } from "@/components/ui";

export function ClaimTypeScopeSelect({
  claimTypes,
  selectedIds,
  onChange,
  label,
  allLabel = "All claim types",
  className,
  disabled = false,
}: {
  claimTypes: { id: string; label: string }[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  label: string;
  allLabel?: string;
  className?: string;
  disabled?: boolean;
}) {
  const allClaimTypeIds = claimTypes.map((claimType) => claimType.id);
  const effectiveSelectedIds =
    selectedIds.length === 0 ? allClaimTypeIds : selectedIds;
  const setIds = (ids: string[]) => {
    const allAvailableSelected =
      claimTypes.length > 0 &&
      claimTypes.every((claimType) => ids.includes(claimType.id)) &&
      ids.length === claimTypes.length;
    onChange(allAvailableSelected ? [] : ids);
  };

  return (
    <MultiSelect
      aria-label={label}
      className={className}
      disabled={disabled}
      modalPopover
      options={claimTypes.map((claimType) => ({
        label: claimType.label,
        value: claimType.id,
      }))}
      selectedValues={effectiveSelectedIds}
      setSelectedValues={(nextIds) => {
        setIds(
          typeof nextIds === "function"
            ? nextIds(effectiveSelectedIds)
            : nextIds,
        );
      }}
      onValueChange={setIds}
      showToggleAll={false}
      allSelectedLabel={allLabel}
      showClearButton={selectedIds.length > 0}
      showCloseButton={false}
      showScrollHints
      placeholder={allLabel}
      maxCount={2}
    />
  );
}
